import { cn } from "@/shared/lib/utils";

export type ControlSize = "sm" | "md" | "lg";

/** Visual base de todo controle de formulário (input, select, textarea). */
export const controlBase = cn(
  "block min-w-0 rounded-md border border-border-strong bg-surface text-body text-fg shadow-xs",
  "placeholder:text-fg-subtle transition-[border-color,box-shadow] duration-150",
  "hover:border-fg-subtle/60",
  "focus:border-focus focus:outline-none focus:ring-3 focus:ring-focus/20 focus-visible:outline-none",
  "disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-fg-disabled disabled:shadow-none",
  "aria-invalid:border-danger aria-invalid:focus:ring-danger/20",
);

export const controlSizes: Record<ControlSize, string> = {
  sm: "h-8 px-2.5 text-body-sm",
  md: "h-9 px-3",
  lg: "h-11 px-3.5",
};
